export default "__VITE_ASSET__By$CI3Yz__"